import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/apiClient";

const homeFor = (role) => role === "super_admin" ? "/admin/super" : role === "business_admin" ? "/business" : "/admin/salon";

export default function AuthCallback() {
  const { applyGoogleSession } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) { nav("/salon/login", { replace: true }); return; }
    applyGoogleSession(sid)
      .then((u) => { toast.success("Signed in with Google"); nav(homeFor(u.role), { replace: true }); })
      .catch((e) => { toast.error(apiErr(e, "Google sign-in failed")); nav("/salon/login", { replace: true }); });
  }, [applyGoogleSession, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-[#4A5550]"><Loader2 className="w-5 h-5 animate-spin" /> Signing you in…</div>
    </div>
  );
}
